<template>
  <div class="trialDetailList">
    <el-card>
      <el-form :inline="true">
        <el-button type="primary" @click="excelDownloadClick">导出数据</el-button>
      </el-form>
      <!-- 返回抽审记录按钮 -->
    <!-- <el-button @click="back" class="csjl" type="primary">{{$t('lang.back_trialNotes')}}</el-button> -->
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" ref="formgb"
        :height="tableData.length>0 ? require('@/config/enum').tableheight540 : require('@/config/enum').tableheight120">
        <!-- 多选框 -->
        <el-table-column type="selection" width="55" v-if="this.trialDetailListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" ></el-table-column>
        <!-- 抽审id -->
        <el-table-column prop="Id" label="抽审ID">
        </el-table-column>
        <!-- 工单id -->
		<el-table-column prop="maintainId" label="工单ID">
		</el-table-column>
        <!-- 小区 -->
        <el-table-column :label="$t('lang.trialDetailList_garden')" prop=Garden >
        </el-table-column>
        <!-- 报事用户 -->
        <el-table-column :label="$t('lang.trialDetailList_user')" prop=UserName width="280px">
        </el-table-column>
        <!-- 报事方式 -->
        <el-table-column :label="$t('lang.trialDetailList_type')" prop=UserId >
          <template slot-scope="scope">
            <span v-if="scope.row.UserId === 0">{{$t('lang.trialDetailList_type_yzbs')}}</span>
            <span v-else>{{$t('lang.trialDetailList_type_htbs')}}</span>
          </template>
        </el-table-column>
        <!-- 报事时间 -->
        <el-table-column :label="$t('lang.trialDetailList_date')" prop=CreateTime  sortable>
          <template slot-scope="scope">{{scope.row.CreateTime | time}}</template>
        </el-table-column>
        <!-- 工单类型 -->
        <el-table-column :label="$t('lang.trialDetailList_normal')" prop=Type >
        </el-table-column>
        <!-- 报事类型 -->
        <el-table-column :label="$t('lang.trialDetailList_trialType')" prop=Normal >
          <template slot-scope="scope">
            <span v-if="scope.row.Normal === 0">{{$t('lang.trialDetailList_normal_zcgd')}}</span>
            <span v-else-if="scope.row.Normal === 1">{{$t('lang.trialDetailList_normal_ysgd')}}</span>
            <span v-else>{{$t('lang.trialDetailList_normal_zbgd')}}</span>
          </template>
        </el-table-column>
        <!-- 是否有子工单 -->
        <el-table-column label="是否有子工单" prop=haveChild >
          <template slot-scope="scope">
            <span v-if="scope.row.HaveChild == 1" @click="haveChildId(scope.row.maintainId)" class="haveChild1style">{{$t('lang.lab_haveChild1Abbr')}}</span>
          </template>
        </el-table-column>
        <!-- 抽审状态 -->
        <el-table-column :label="$t('lang.trialDetailList_state')" prop=State >
          <template slot-scope="scope">
            <span v-if="scope.row.State === 1">{{$t('lang.trialDetailList_state_dcs')}}</span>
            <span v-if="scope.row.State === 2">{{$t('lang.trialDetailList_state_hg')}}</span>
            <span v-if="scope.row.State === 3" class="red">{{$t('lang.trialDetailList_state_bhg')}}</span>
            <span v-if="scope.row.State === 4">优秀</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" prop="operation" fixed="right"
         >
          <!-- 详情按钮 -->
          <template slot-scope="scope">
            <el-button @click="detail(scope.row.maintainId,scope.row.Id,scope.row.State,scope.row.HaveChild,)">{{$t('lang.trialDetailBtn')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 999]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>

  </div>
</template>

<script>
import {
    excelDownload
  } from '../../../config/download.js'
  /**
   *@ClassName:trialDetailList
   *@Description:抽审记录详情
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-05-12
   */
  export default {
    name:'/manage/trialDetailList',
    data() {
      return {
        id: '', // 抽审记录id
        drawName:'',
        pageCount: 0, // 总页数
        pageNum: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 抽审记录详情列表
        trialDetailListcheckbox: require('@/config/enum').trialDetailListcheckbox, // 是否隐藏复选框
      }
    },
    watch: {
      tableData(val) {
        if (val) {
          this.$nextTick(() => {
                  this.$refs['formgb'].doLayout()
          })
        }
      }
     },
    created() {
       if(this.$route.query.detailListId){
          this.id = this.$route.query.detailListId
          this.drawName=this.$route.query.drawName
       }else{
          this.id = this.$route.query.row.Id
          this.drawName = this.$route.query.row.Name
       }
      if(this.$route.query.detailListNum){
         this.pageNum = this.$route.query.detailListNum 
      }
      if(this.$route.query.detailListCount){
        this.pageCount = this.$route.query.detailListCount
      }
      // 获取抽审记录详情列表方法
      this.getList()
    },
    activated() {
     this.getList()
    },
    methods: {
      // 返回抽审记录
      back() {
        this.$router.push({
          name: 'trialNotes'
        })
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.getList()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 抽审记录详情列表方法
      getList() {
        let loading = this.$loading()
        this.$get(
          `/randomInspectionDetails/${this.id}?pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // debugger
              // 渲染抽审记录详情列表
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      exportData() {
        let loading = this.$loading()
        let params = {}
        this.$get(`/randomInspectionExport/${this.id}`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              window.open(res.webUrl)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      excelDownloadClick() {
        if (navigator.onLine) {
          let SendSource = ''
          let CreateTime = ''
          let Normal = ''
          let State = ''
          const tHeader = [
            '小区','报事用户','报事方式','报事时间','报事类型','工单类型','抽审状态','工单编号','工单详情','楼号','单元号','房间号'
          ]
          let newArr = []
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].UserId === 0) {
                  SendSource = this.$i18n.t('lang.trialDetailList_type_yzbs')
              } else {
                  SendSource = this.$i18n.t('lang.trialDetailList_type_htbs')
              }
              if (this.tableData[i].CreateTime) {
                  CreateTime = this.$options.filters['timeYMD'](this.tableData[i].CreateTime)
              }
              if (this.tableData[i].Normal === 0) {
                  Normal = this.$i18n.t('lang.trialDetailList_normal_zcgd')
              } else if (this.tableData[i].Normal === 1){
                  Normal = this.$i18n.t('lang.trialDetailList_normal_ysgd')
              } else {
                  Normal = this.$i18n.t('lang.trialDetailList_normal_zbgd')
              }
              if (this.tableData[i].State === 1) {
                  State = this.$i18n.t('lang.trialDetailList_state_dcs')
              } else if (this.tableData[i].State === 2) {
                  State = this.$i18n.t('lang.trialDetailList_state_hg')
              } else if (this.tableData[i].State === 4) {
                  State = '优秀'
              } else {
                  State = this.$i18n.t('lang.trialDetailList_state_bhg')
              }
              newArr.push({
                'Garden': this.tableData[i].Garden,
                'UserName': this.tableData[i].UserName,
                'SendSource': SendSource,
                'CreateTime': CreateTime,
                'Type': this.tableData[i].Type,
                'Normal': Normal,
                'State': State,
                'maintainId':this.tableData[i].maintainId,
                'Content':this.tableData[i].Content,
                'HouseName':this.tableData[i].HouseName,
                'UnitName':this.tableData[i].UnitName,
                'RoomName':this.tableData[i].RoomName,
              })
            }
          }
          const filterVal = ['Garden','UserName','SendSource','CreateTime','Type','Normal','State','maintainId','Content','HouseName','UnitName','RoomName']
          excelDownload(tHeader, filterVal, newArr, this.drawName)
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 抽审记录详情方法
      detail(maintainId, id, State, haveChild) {
         this.$router.push({ name: 'trialOrderDetail', query: { id: maintainId, hege: State, rimId: id, detailListId:this.id,drawName:this.drawName,detailListNum:this.pageNum,detailListCount:this.pageCount,haveChild:haveChild} })
      },
      // 点击子工单
      haveChildId(maintainId) {
        sessionStorage.setItem('haveChildParentId', maintainId)
        this.$router.push({
          name: 'projectWideRepoInfoList',
          query: {
              trialDetailList: true
            }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .trialDetailList .csjl {
    margin-bottom: 10px;
    float: right;
  }
  .el-table__fixed-right{

    height: 100% !important;

  }

  .el-table__fixed-body-wrapper {

    max-height: 100% !important

  }
  .haveChild1style {
    margin-left: 2px;
    border: 1px solid #4682b4;
    background-color: #4682b4;
    color: #ffffff;
    cursor: pointer;
  }
</style>